import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { appConfig } from "@/lib/AppConfig";
import { ValidationError } from "@/types/problemDetails";
import type { LayoutContext } from "@/lib/models";
import { setFormErrors } from "@/lib/react-form-utils";
import { CacheService } from "@/services/CacheService";
import { SiteService, type SiteSummary, } from "@/services/SiteService";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext, useParams } from "react-router";

const SiteIndexPage: React.FC = () => {
  const params = useParams();
  const [siteName, setSiteName] = useState<string | null>(null);
  const { setPageName } = useOutletContext<LayoutContext>();
  const { register, handleSubmit, formState: { isDirty, errors }, reset, setError } = useForm<SiteSummary>();
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const site = await SiteService.getSiteById(params.siteId!);
        setSiteName(site.name);
        setPageName(`Site: ${site.name}`);
        reset(site);
      } catch (error) {
        console.error('Fetch failed:', error);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.siteId]);

  useEffect(() => {
    setIsSaveDisabled(!isDirty);
  }, [isDirty]);  

  const handleFormSubmit = async (formData: SiteSummary) => {
    if (!params.siteId) {
      alert('error invalid siteId')
      return null
    }
    const updatedArea: SiteSummary = {
      ...formData,
    };

    try {
        await SiteService.updateSiteSummary(params.siteId!, updatedArea);
        reset({...updatedArea});
        setSiteName(updatedArea.name)
        CacheService.clear(appConfig.resourceTypes.site, params.siteId!);

    } catch (error) {
        if (error instanceof ValidationError) {
          setFormErrors<SiteSummary>(error.errors, setError, updatedArea)
        }
    }
    return null;
  };

  return (
    <div className="container mx-auto p-4">
      <Header headerTitle={siteName ? `Site: ${siteName}` : ""} />
      <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
        <div>
          <Label
            htmlFor="name"
          >
            Name *
          </Label>
          <Input
            type="text"
            {...register("name", { required: 'Name is required'})}
          />
          <span className="text-sm text-red-500">{errors.name?.message}</span>
        </div>
        <div>
          <Label
            htmlFor="description"
          >
            Description
          </Label>
          <Input
            type="text"
            {...register("description")}
          />
          <span className="text-sm text-red-500">{errors.description?.message}</span>
        </div>        
        <div className="flex justify-end space-x-2">
          <button
            type="reset"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Cancel
          </button>
          <Button
            type="submit"
            disabled={isSaveDisabled}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Update Area
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SiteIndexPage;
